import React, { useCallback, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "tss-react/mui";

import { Box, Button, CircularProgress, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import api from "../../services/api";
import ToastError from "../../toast/error/toastError";

const useStyles = makeStyles()((theme) => ({
	root: {
		padding: theme.spacing(1.5, 2),
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		gap: theme.spacing(1.5),
		borderBottom: `1px solid ${theme.palette.divider}`,
		backgroundColor: theme.palette.background.paper,
	},
	label: {
		fontSize: 11,
		fontWeight: 600,
		textTransform: "uppercase",
		letterSpacing: 0.5,
		color: theme.palette.text.secondary,
	},
	button: {
		fontSize: 12,
		fontWeight: 600,
		textTransform: "none",
		borderRadius: 4,
		padding: theme.spacing(0.75, 1.5),
		boxShadow: "none",
		flexShrink: 0,
		"&:hover": { boxShadow: "none" },
	},
}));

const PendingTicketsCompactPreview = ({ onAccepted }) => {
	const { classes } = useStyles();
	const history = useHistory();
	const [accepting, setAccepting] = useState(false);
	const isMountedRef = useRef(true);

	React.useEffect(() => () => { isMountedRef.current = false; }, []);

	const handleAccept = useCallback(async (e) => {
		e?.stopPropagation?.();
		if (accepting) return;
		setAccepting(true);
		try {
			localStorage.removeItem("ticket_accept");
			const { data } = await api.post("/tickets/accept-next");
			const ticket = data?.ticket;
			if (ticket?.id) {
				localStorage.setItem("ticket_accept", ticket.id);
				document.querySelector("#openTickets")?.click();
				if (ticket.uuid) history.push(`/tickets/${ticket.uuid}`);
			}
			onAccepted?.();
		} catch (err) {
			ToastError(err);
		} finally {
			if (isMountedRef.current) setAccepting(false);
		}
	}, [accepting, history, onAccepted]);

	return (
		<Box className={classes.root}>
			<Typography className={classes.label}>Tickets aguardando</Typography>
			<Button
				className={classes.button}
				variant="contained"
				color="primary"
				size="small"
				disableElevation
				disabled={accepting}
				onClick={handleAccept}
				startIcon={accepting
					? <CircularProgress size={12} thickness={5} sx={{ color: "inherit" }} />
					: <PlayArrowIcon sx={{ fontSize: 14 }} />
				}
			>
				{accepting ? "Aceitando" : "Atender próximo"}
			</Button>
		</Box>
	);
};

export default PendingTicketsCompactPreview;
